<template>
  <section :class="collapsible ? 'mt-[48px]' : ''">
    <button
      v-if="collapsible"
      type="button"
      class="flex items-center gap-x-[6px] border-t border-gpx_gray-800 pt-[24px] text-gpx_sm font-medium text-gpx_gray-200"
      :aria-expanded="isOpen"
      @click="isOpen = !isOpen"
    >
      <ChevronRightIcon
        class="heroicon-stroke-w-1.4 size-[16px] transition-transform"
        :class="{ 'rotate-90': isOpen }"
      />
      <span>Legacy API key</span>
    </button>

    <HeadingSection
      v-else
      class="mb-[35px]"
      desc="View or Reset your API Token"
      heading="API Access"
    />

    <div v-if="!collapsible || isOpen" :class="collapsible ? 'mt-[18px]' : ''">
      <p v-if="collapsible" class="mb-[18px] text-gpx_sm text-gpx_gray-200">
        For the older API only. It does not authenticate against the public API
        above.
      </p>
      <div class="flex">
        <UIInput
          class="w-full"
          inputClass="!rounded-r-none"
          :modelValue="account?.api_token"
          readonly
        />
        <button
          class="flex items-center space-x-2 rounded-r-none border-x border-gpx_gray-700 bg-bg-3 px-6"
          @click="handleCopyApiToken"
        >
          <component :is="copyIcon" class="size-5" />
          <span>{{ isCopied ? 'Copied' : 'Copy' }}</span>
        </button>
        <button
          class="flex items-center space-x-2 rounded-r-[6px] bg-bg-3 px-6"
          :disabled="processing"
          @click="handleResetToken"
        >
          <ArrowPathIcon class="size-5" />
          <span>{{ processing ? 'Reseting...' : 'Reset' }}</span>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { useToast } from 'vue-toastification';
import HeadingSection from '@/components/_common/Heading/HeadingSection.vue';
import {
  ArrowPathIcon,
  ChevronRightIcon,
  DocumentDuplicateIcon,
} from '@heroicons/vue/24/outline';
import { DocumentDuplicateIcon as DocumentDuplicateIconSolid } from '@heroicons/vue/24/solid';
import { copyTextToClipboard } from '@/utils/copy-to-clipboard';

export default {
  components: {
    HeadingSection,
    ArrowPathIcon,
    ChevronRightIcon,
    DocumentDuplicateIcon,
    DocumentDuplicateIconSolid,
  },

  props: {
    /** Tucks the key away below the public API tokens, for an account entitled to both. */
    collapsible: {
      type: Boolean,
      default: false,
    },
  },

  setup() {
    const toast = useToast();
    return { toast };
  },

  data() {
    return {
      processing: false,
      isCopied: false,
      isOpen: false,
    };
  },

  computed: {
    ...mapGetters({
      account: 'auth/account',
    }),
    copyIcon() {
      return this.isCopied ? DocumentDuplicateIconSolid : DocumentDuplicateIcon;
    },
  },

  methods: {
    ...mapActions({
      resetToken: 'auth/resetToken',
    }),
    async handleCopyApiToken() {
      try {
        await copyTextToClipboard(this.account.api_token);
        this.toast.success('Copied!');
        this.isCopied = true;
      } catch {
        this.toast.error(
          'Could not copy. Select the key and copy it manually.',
        );
      }
    },
    handleResetToken() {
      this.processing = true;
      this.resetToken({ accountId: this.account.id }).finally(() => {
        this.processing = false;
      });
    },
  },
};
</script>
